<template>
  <v-app-bar app :elevation="0" elevate-on-scroll color="bgWhite" height="90px">
    <v-app-bar-nav-icon v-if="!sideBar" @click.stop="setSideBar(!sideBar)" style="margin-left: 0px;"/>

    <app-breadcrumb :menu="menu" />

    <v-spacer></v-spacer>

    <div class="mt-5 d-flex align-center mb-5 navbar-container">
      <div class="self-end d-none d-sm-block">
        <div
          class="font-weight-bold bluePrimary--text mt-2"
          style="line-height: 0.8"
        >
          {{ getFullName || 'Invitado' }}
        </div>
        <v-tooltip bottom v-if="$vuetify.breakpoint.xs">
          <template v-slot:activator="{ on, attrs }">
            <div class="text-caption bluePrimary--text perfil-text" v-bind="attrs" v-on="on">
              {{ getPerfil }}
            </div>
          </template>
          <span>{{ getPerfil }}</span>
        </v-tooltip>
        <div v-else class="text-caption bluePrimary--text">
          {{ getPerfil }}
        </div>
      </div>
      <bell-notification />
      <div class="circular-avatar" v-if="fotoUsuario">
        <img :src="fotoUsuario" alt="Foto de perfil" class="circular-image" />
      </div>
      <v-icon v-else size="40" color="#1c1e4d">mdi-account-circle</v-icon>
      <v-icon size="20" color="#1c1e4d">mdi-logout</v-icon>
      <span
        @click="cerrarSession()"
        class="text-decoration-underline"
        style="cursor: pointer; color: #1c1e4d"
      >
        Cerrar sesión
      </span>
    </div>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import authServices from '../services/auth.services';
import jwtDecode from 'jwt-decode';
import BellNotification from './BellNotification.vue';
import AppBreadcrumb from './AppBreadcrumb.vue';
export default {
  name: 'AppHeader',
  components: { BellNotification, AppBreadcrumb },
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      reintentosPerfiles: 0,
      perfiles: [],
    };
  },
  methods: {
    ...mapMutations('utils', ['setSideBar', 'setMenu', 'setRoles']),
    ...mapMutations(['setToken', 'setInfoInstitucionLogo']),
    async cerrarSession() {
      // console.log("cerrarSession");
      let tokenIdentidad = localStorage.getItem('identidadToken');
      let token = localStorage.getItem('token');
      this.setMenu([]);
      this.setToken(null);
      this.setRoles([]);
      localStorage.removeItem('roles');
      try {
        await authServices.logout(token, tokenIdentidad);
        localStorage.clear();
        sessionStorage.clear();
        this.setInfoInstitucionLogo({
          posee_logo: null,
          es_configurador: null,
          posee_establecimientos: null,
        });
        this.$router.push({ name: 'login' }).catch(() => {});
      } catch {
        this.$store.commit('utils/setLoader', false);
      }
    },
    verificarPerfiles() {
      const userToken = localStorage.getItem('token');
      const userDecode = jwtDecode(userToken);
      let perfiles = userDecode.puesto?.perfiles;
      if (!Array.isArray(perfiles) || perfiles.length === 0) {
        if (this.reintentosPerfiles < 5) {
          this.reintentosPerfiles++;
          setTimeout(() => this.verificarPerfiles(), 300);
        } else {
          this.perfiles = this.userInfo?.perfiles || [];
        }
      } else {
        this.perfiles = perfiles;
      }
    },
    breakpoint() {
      if (this.$vuetify.breakpoint.sm) {
        return false;
      } else if (this.$vuetify.breakpoint.xs) {
        return false;
      } else if (this.$vuetify.breakpoint.md) {
        return true;
      } else if (this.$vuetify.breakpoint.lg) {
        return true;
      } else if (this.$vuetify.breakpoint.xl) {
        return true;
      } else {
        return true;
      }
    },
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('utils', {
      sideBar: 'sideBar',
      menu: 'menu',
    }),
    fotoUsuario() {
      return localStorage.getItem('userPhoto') || null;
    },
    getFullName() {
      const { nombres, apellidos } = this.userInfo.user || {};

      // Extrae el primer nombre y el primer apellido
      const primerNombre = nombres ? nombres.split(' ')[0] : '';
      const primerApellido = apellidos ? apellidos.split(' ')[0] : '';

      return `${primerNombre} ${primerApellido}`.trim();
    },
    getPerfil() {
      let perfiles = this.perfiles || [];
      if (Array.isArray(perfiles) && perfiles.length >= 1) {
        if (perfiles.length == 1) {
          return perfiles[0].nombre;
        } else {
          return perfiles.map(perfil => perfil.nombre).join(', ');
        }
      }
      return '';
    },
    col1Breakpoint() {
      if (this.$vuetify.breakpoint.xs) {
        if (this.$vuetify.breakpoint.width < 500) {
          return 8;
        } else {
          return 7;
        }
      } else {
        return 7;
      }
    },
    col2Breakpoint() {
      if (this.$vuetify.breakpoint.xs) {
        if (this.$vuetify.breakpoint.width < 500) {
          return 4;
        } else {
          return 5;
        }
      } else {
        return 5;
      }
    },
  },
  created() {
    this.verificarPerfiles();
  },
};
</script>

<style scoped lang="scss">
.btn__hover {
  &:hover {
    background-color: #f4f7fd !important;
  }
}

.icon__color {
  color: #697182 !important;
}

.circular-container {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #1c1e4d;
  /* Fondo azul */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
}

.circular-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circular-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
</style>

<style scoped>
.contenedor-inline {
  display: inline-block;
  /* Hace que el contenedor se ajuste al ancho del contenido (el botón). */
}

.wrap-text-sub {
  max-width: 228px;
  /* Limita el ancho */
  display: block;
  /* Asegura que sea un bloque que ocupe 100% del contenedor */
  width: 100%;
  /* Ocupa todo el ancho del contenedor padre */
  white-space: normal;
  /* Permite saltos de línea */
  word-break: break-word;
  /* Rompe las palabras largas si exceden el ancho */
  text-align: center;
}

.navbar-container {
  color: #1c1e4d;
  width: 30%;
  padding-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
}

@media screen and (max-width: 1024px) {
  .navbar-container {
    width: 60%;
  }
}

@media screen and (max-width: 600px) {
  .navbar-container {
    width: auto;
    padding-right: 0.5rem;
    gap: 0.5rem;
  }
}

@media screen and (max-width: 600px) {
  .perfil-text {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
